<template>
  <vs-row
  vs-type="flex"  vs-justify="center" vs-align="center" vs-w="12">
  {{params.data.due_date | dateFormatLocalization}}
  {{params.data.due_date | timeFormatLocalization}}
  <!-- <flat-pickr class="deadline"  v-model="params.data.due_date" disabled  :config="configdateTimePicker1"/> -->
  </vs-row>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
   
    flatPickr
    
  },
  data () {
    return {

      configdateTimePicker1: {
        enableTime: true,
        //time_24hr: localStorage.getItem('time') == 2,
        enableSeconds: true,
        noCalendar: false,
        altInput: true
        //altFormat: localStorage.getItem('time') == 2 ? `${localStorage.getItem('date_format')  } H:i:S` : `${localStorage.getItem('date_format')  } h:i:S K`
        
      }
    }
  }
}
</script>

<style>
.deadline.form-control.input{
    border: none;
    text-align: center;

}
</style>
